import React from 'react';

import { PlainTextEditor } from '../../../PlainTextEditor';
import type { PlainTextEditorProps } from '../../../PlainTextEditor';

// Styles are authored in `Profile.scss`

export type TitleProps = Pick<
    PlainTextEditorProps,
    | 'placeholder'
    | 'value'
    | 'editMode'
    | 'editing'
    | 'characterLimit'
    | 'onEnableEditing'
    | 'onDisableEditing'
    | 'onUpdateValue'
    | 'onChange'
>;

export const PROFILE_TITLE_ID_EDITABLE = 'Profile-Title-Editable';

export function Title({
    placeholder,
    value,
    editMode,
    editing,
    characterLimit,
    onEnableEditing,
    onDisableEditing,
    onChange,
    onUpdateValue,
}: TitleProps) {
    function handleChange(val?: string | null) {
        onChange?.(val);
    }

    return (
        <div className="Yat_Profile-Title">
            <PlainTextEditor
                heading
                id={PROFILE_TITLE_ID_EDITABLE}
                placeholder={placeholder}
                value={value}
                editMode={editMode}
                characterLimit={characterLimit}
                editing={editing}
                onChange={handleChange}
                onEnableEditing={onEnableEditing}
                onDisableEditing={onDisableEditing}
                onUpdateValue={onUpdateValue}
            />
        </div>
    );
}
